import { EVENT_ARTIFACT_FIELDS } from './event-artifact-fields';
export const STRUCTURED_CONTENT_FIELDS = `
    artifactIds
    artifacts {
        place {provider providerPlaceId displayName formattedAddress mapUrl categories rating ratingCount priceRange
            location {lat lng} geo {type coordinates}}
        ${EVENT_ARTIFACT_FIELDS}
        id
        owner
        sourceMessageId
        type
        semanticTypes
        title
        summary
        image
        sourceUrls
        metadata {
            key
            label
            value
        }
        sections {
            id
            kind
            title
            checkable
            entries {
                id
                label
                text
                detail
                quantity
                unit
                optional
                duration
                mediaRef
                order
                emoji
            }
        }
        schemaVersion
        extractionVersion
        viewerState {
            id
            artifact
            user
            status
            contextTags
            checkedEntryIds
            rating
            notes
            completedAt
            updatedAt
        }
        createdAt
        updatedAt
    }
    structuredContent {
        schemaVersion
        type
        title
        summary
        metadata {
            key
            label
            value
        }
        sections {
            id
            kind
            title
            checkable
            entries {
                id
                label
                text
                detail
                quantity
                unit
                optional
                duration
                mediaRef
                order
                emoji
            }
        }
    }
    structuredContentState {
        checkedEntryIds
        updatedAt
    }
`;
